module.exports = __webpack_public_path__ + "img/1f9cb.b208e4e.svg";